import {useCallback, useEffect, useState} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {LocationType, LocationTypes} from '@/src/hooks/useCountriesList';
import fetchCitiesDictionary from '@/src/signUp/emailStep/utils/fetchCitiesDictionary';
import fetchCitiesDictionaryWithClinics from '@/src/signUp/emailStep/utils/fetchCitiesDictionaryWithClinics';
import fetchCitiesDictionaryWithUsers from '@/src/signUp/emailStep/utils/fetchCitiesDictionaryWithUsers';
import fetchCitiesDictionaryWithVacancies from '@/src/signUp/emailStep/utils/fetchCitiesDictionaryWithVacancies';

const METHODS = {
  [LocationTypes.ALL]: fetchCitiesDictionary,
  [LocationTypes.WITH_VACANCY]: fetchCitiesDictionaryWithVacancies,
  [LocationTypes.WITH_CLINICS]: fetchCitiesDictionaryWithClinics,
  [LocationTypes.WITH_USERS]: fetchCitiesDictionaryWithUsers,
};

const useCitiesList = (
  stateId,
  citiesType: LocationType = LocationTypes.ALL,
  clinicId = null
) => {
  const [citiesList, setCitiesList] = useState([]);

  const getCities = useCallback(
    async (stateId) => {
      if (!stateId) {
        return setCitiesList([]);
      }

      const {responseBody, status} = await METHODS[citiesType](
        stateId,
        clinicId
      );

      if (status === RESPONSE_STATUSES.SUCCESS) {
        setCitiesList(responseBody.data);
      }
    },
    [setCitiesList]
  );

  useEffect(() => {
    getCities(stateId);
  }, [stateId]);

  return {
    citiesList,
  };
};

export default useCitiesList;
